<template>

    <div ref="chart" class="chart"></div>

</template>

<script>

    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);
    am4core.useTheme(am4themes_animated);

    export default {

        props: {
            score: {
                type: Number,
                required: true,
                default: 0
            }
        },

        data() {
            return {
                hand: null,
            }
        },

        watch: {
            score(value) {
                this.hand.showValue(value);
            }
        },

        mounted() {

            let chart = am4core.create(this.$refs.chart, am4charts.GaugeChart);
            chart.innerRadius = -15;
            chart.startAngle = 90;
            chart.endAngle = 270;
            //chart.paddingTop = 40;
            //chart.background.fill = '#FFFFFF';

            let axis = chart.xAxes.push(new am4charts.ValueAxis());
            axis.min = 0;
            axis.max = 100;
            //axis.fill = am4core.color("#000000");
            //axis.fontSize = 25;
            axis.strictMinMax = true;
            axis.renderer.labels.template.fill = am4core.color("#DDD");
            axis.renderer.grid.template.stroke = am4core.color("#FFF");
            axis.renderer.grid.template.strokeWidth = 1;
            axis.renderer.grid.template.strokeOpacity = 0.5;

            let rangeRed = axis.axisRanges.create();
            rangeRed.value = 0;
            rangeRed.endValue = 30;
            rangeRed.axisFill.strokeWidth = 1;
            rangeRed.axisFill.stroke = am4core.color("#FFFFFF");
            rangeRed.axisFill.fillOpacity = 1;
            rangeRed.axisFill.fill = am4core.color("#952121");
            rangeRed.axisFill.zIndex = -1;

            let rangeYellow = axis.axisRanges.create();
            rangeYellow.value = 30;
            rangeYellow.endValue = 70;
            rangeYellow.axisFill.strokeWidth = 1;
            rangeYellow.axisFill.stroke = am4core.color("#FFFFFF");
            rangeYellow.axisFill.fillOpacity = 1;
            rangeYellow.axisFill.fill = am4core.color("#bdb33a");
            rangeYellow.axisFill.zIndex = -1;

            let rangeGreen = axis.axisRanges.create();
            rangeGreen.value = 70;
            rangeGreen.endValue = 100;
            rangeGreen.axisFill.strokeWidth = 1;
            rangeGreen.axisFill.stroke = am4core.color("#FFFFFF");
            rangeGreen.axisFill.fillOpacity = 1;
            rangeGreen.axisFill.fill = am4core.color("#5cab5c");
            rangeGreen.axisFill.zIndex = -1;

            this.hand = chart.hands.push(new am4charts.ClockHand());
            this.hand.radius = am4core.percent(100);
            this.hand.fill = am4core.color("#58B0F6");
            this.hand.strokeWidth = 0;
            this.hand.startWidth = 11;

            //this.hand.fill = am4core.color("#58B0F6");
            //this.hand.stroke = am4core.color("#FFFFFF");
            //hand.innerRadius = am4core.percent(50);

            this.hand.showValue(this.score);
        }
    }
</script>

<style scoped>
    .chart {
        height: 600px;
    }
</style>